/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetOtpByIdDto } from '../models/custom-result-of-get-otp-by-id-dto';
import { CustomResultOfPaginatedListOfGetOtpsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-otps-with-pagination-dto';
import { otpsCreateGet } from '../fn/otps/otps-create-get';
import { OtpsCreateGet$Params } from '../fn/otps/otps-create-get';
import { otpsCreatePost } from '../fn/otps/otps-create-post';
import { OtpsCreatePost$Params } from '../fn/otps/otps-create-post';
import { otpsDelete } from '../fn/otps/otps-delete';
import { OtpsDelete$Params } from '../fn/otps/otps-delete';
import { otpsGetOtpAudits } from '../fn/otps/otps-get-otp-audits';
import { OtpsGetOtpAudits$Params } from '../fn/otps/otps-get-otp-audits';
import { otpsGetOtpsWithPagination } from '../fn/otps/otps-get-otps-with-pagination';
import { OtpsGetOtpsWithPagination$Params } from '../fn/otps/otps-get-otps-with-pagination';
import { otpsUpdateGet } from '../fn/otps/otps-update-get';
import { OtpsUpdateGet$Params } from '../fn/otps/otps-update-get';
import { otpsUpdatePut } from '../fn/otps/otps-update-put';
import { OtpsUpdatePut$Params } from '../fn/otps/otps-update-put';
import { otpsUpdateStatusGet } from '../fn/otps/otps-update-status-get';
import { OtpsUpdateStatusGet$Params } from '../fn/otps/otps-update-status-get';
import { otpsUpdateStatusPut } from '../fn/otps/otps-update-status-put';
import { OtpsUpdateStatusPut$Params } from '../fn/otps/otps-update-status-put';

@Injectable({ providedIn: 'root' })
export class OtpsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `otpsCreateGet()` */
  static readonly OtpsCreateGetPath = '/Otps/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsCreateGet$Response(params?: OtpsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return otpsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsCreateGet(params?: OtpsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.otpsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `otpsCreatePost()` */
  static readonly OtpsCreatePostPath = '/Otps/Create';

  /**
   * Create Otp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsCreatePost$Response(params: OtpsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return otpsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Otp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsCreatePost(params: OtpsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.otpsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `otpsUpdatePut()` */
  static readonly OtpsUpdatePutPath = '/Otps';

  /**
   * Update Otp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsUpdatePut$Response(params: OtpsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return otpsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Otp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsUpdatePut(params: OtpsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.otpsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `otpsUpdateGet()` */
  static readonly OtpsUpdateGetPath = '/Otps/Update/{id}';

  /**
   * Get Otp by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsUpdateGet$Response(params: OtpsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOtpByIdDto>> {
    return otpsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Otp by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsUpdateGet(params: OtpsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetOtpByIdDto> {
    return this.otpsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOtpByIdDto>): CustomResultOfGetOtpByIdDto => r.body)
    );
  }

  /** Path part for operation `otpsDelete()` */
  static readonly OtpsDeletePath = '/Otps/{id}';

  /**
   * Delete Otp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsDelete$Response(params: OtpsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return otpsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Otp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsDelete(params: OtpsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.otpsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `otpsUpdateStatusPut()` */
  static readonly OtpsUpdateStatusPutPath = '/Otps/UpdateStatus';

  /**
   * Update Otp Status.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsUpdateStatusPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsUpdateStatusPut$Response(params: OtpsUpdateStatusPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return otpsUpdateStatusPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Otp Status.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsUpdateStatusPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsUpdateStatusPut(params: OtpsUpdateStatusPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.otpsUpdateStatusPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `otpsUpdateStatusGet()` */
  static readonly OtpsUpdateStatusGetPath = '/Otps/UpdateStatus/{id}';

  /**
   * Get Otp by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsUpdateStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsUpdateStatusGet$Response(params: OtpsUpdateStatusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOtpByIdDto>> {
    return otpsUpdateStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Otp by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsUpdateStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  otpsUpdateStatusGet(params: OtpsUpdateStatusGet$Params, context?: HttpContext): Observable<CustomResultOfGetOtpByIdDto> {
    return this.otpsUpdateStatusGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOtpByIdDto>): CustomResultOfGetOtpByIdDto => r.body)
    );
  }

  /** Path part for operation `otpsGetOtpAudits()` */
  static readonly OtpsGetOtpAuditsPath = '/Otps/GetOtpAudits';

  /**
   * Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsGetOtpAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsGetOtpAudits$Response(params: OtpsGetOtpAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return otpsGetOtpAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsGetOtpAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsGetOtpAudits(params: OtpsGetOtpAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.otpsGetOtpAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `otpsGetOtpsWithPagination()` */
  static readonly OtpsGetOtpsWithPaginationPath = '/Otps/GetOtpsWithPagination';

  /**
   * Get Otps with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `otpsGetOtpsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsGetOtpsWithPagination$Response(params: OtpsGetOtpsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetOtpsWithPaginationDto>> {
    return otpsGetOtpsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Otps with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `otpsGetOtpsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  otpsGetOtpsWithPagination(params: OtpsGetOtpsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetOtpsWithPaginationDto> {
    return this.otpsGetOtpsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetOtpsWithPaginationDto>): CustomResultOfPaginatedListOfGetOtpsWithPaginationDto => r.body)
    );
  }

}
